<template>
  <div class="cp-backdrop" v-if="show" @click.self="close" aria-modal="true" role="dialog">
    <div class="cp-container">
      <header class="cp-header mb-3 text-center">
        <img
          v-if="logoUrl"
          :src="logoUrl"
          alt="Logomarca"
          class="cp-logo"
          @error="onImgError"
        />
        <h6 class="m-0">Alterar Senha</h6>
      </header>

      <!-- Reusa o formulário “puro” -->
      <div class="cp-form">
        <AlterarSenhaForm @success="onSuccess" @cancel="close" />
      </div>

      <footer class="cp-footer text-center mt-3">
        <p>&copy; {{ new Date().getFullYear() }} - TOQ Soluções / Khodr & Cabral</p>
        <a href="#" @click.prevent>Termos de uso</a>
      </footer>
    </div>
  </div>
</template>

<script>
import AlterarSenhaForm from './AlterarSenhaForm.vue';
import api from '@/services/axios';

export default {
  name: 'AlterarSenhaModal',
  components: { AlterarSenhaForm },
  props: { show: { type: Boolean, default: false } },
  emits: ['close', 'success'],
  computed: {
    logoUrl() {
      return this.$globalState?.logoPath || '';
    },
  },
  methods: {
    close() { this.$emit('close'); },
    onSuccess() { this.$emit('success'); this.close(); },
    resolveApiBase() {
      const instBase = api?.defaults?.baseURL;
      if (instBase) return instBase;
      const envVite = (typeof import.meta !== 'undefined' && import.meta.env) ? import.meta.env : {};
      return envVite.VITE_API_BASE_URL || process.env.VUE_APP_API_URL || '/api';
    },
    onImgError(e) {
      e.target.src =
        "data:image/svg+xml;utf8," +
        encodeURIComponent(
          `<svg xmlns='http://www.w3.org/2000/svg' width='240' height='80'>
             <rect width='100%' height='100%' fill='#f2f2f2'/>
             <text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle'
                   font-family='sans-serif' font-size='14' fill='#888'>sem logomarca</text>
           </svg>`
        );
    },
  },
};
</script>

<style scoped>
/* backdrop ocupa a tela toda, igual ao reset */
.cp-backdrop {
  position: fixed; inset: 0;
  background: rgba(0,0,0,.35);
  display: flex; align-items: center; justify-content: center;
  z-index: 2000;
}

/* cartão central com o mesmo “feeling” do ResetPassword.vue */
.cp-container {
  background: rgba(255, 255, 255, 0.98);
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0,0,0,.3);
  max-width: 420px;
  width: 92%;
}

.cp-logo {
  width: 200px;
  margin-bottom: 10px;
}

.cp-form :deep(.form-group) {   /* caso use classes do form */
  margin-bottom: 15px;
  text-align: left;
}

.cp-footer {
  font-size: 12px;
  color: #777;
}
.cp-footer a {
  color: #007bff;
  text-decoration: none;
  font-size: 12px;
}
.cp-footer a:hover { text-decoration: underline; }
</style>
